import POIStepsWrapper from "@/components/POI/POIStepsWrapper/POIStepsWrapper.vue";
import ValidationDialog from "@/components/Common/ValidationDialog/ValidationDialog.vue";
import "./POIEditDialog.scss";
import {
  getObjectDiff,
  getThirdPartySystem,
  isEmptyValue,
  getPrincipalName,
  getIsOwnedBySubPrincipalWarningHTML,
  onCKEditorReady
} from "@/helpers/commonHelper";
import { imports } from "@/helpers/poiHelper";
export default {
  props: [
    "regions",
    "editedItem",
    "editedIndex",
    "categoryGroups",
    "categoryTypes",
    "principals",
    "editedItem",
    "dialog",
    "step",
    "isValid"
  ],
  data: () => ({
    errorList: [],
    errorDialog: false,
    initialPOI: {},
    validStepsForOwnedBySubPrincipal: [8],
    editorUrl: "https://cdn.eberl-online.cloud/ckeditor5/ckeditor5.js"
  }),
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    isOwnedBySubPrincipalWarningHTML() {
      const principalName = this.getPrincipalName(this.editedItem.principal);
      return this.getIsOwnedBySubPrincipalWarningHTML(principalName);
    },
    formTitle() {
      return `${
        this.editedItem.title
          ? `'${this.editedItem.title}'`
          : "Point of Interest"
      } ${this.editedIndex === -1 ? "anlegen" : "bearbeiten"}`;
    },
    importedFromString() {
      if (!this.importedFrom?.length) {
        return;
      }

      return `${this.importedFrom
        .map(str => str.replace("-ID", ""))
        .join(", ")}-Import`;
    },
    activeImports() {
      return imports
        .filter(_ => _.isActive(this.currentPrincipal))
        .map(_ => _.typeId);
    },
    importedFrom() {
      if (!this.editedItem.additionalData?.length) {
        return;
      }
      const importedFrom = this.activeImports.filter(systemId =>
        this.editedItem.additionalData.find(d => d.typeId === systemId)
      );
      return importedFrom;
    },
    thirdPartySystems() {
      const typeIds = this.importedFrom;
      return this.getThirdPartySystem(typeIds, "POIs");
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    isRegionEditUser() {
      return (
        this.currentUser?.scopes.includes("role:regions_edit") ||
        this.currentUser?.principal_id === this.REGION_PRINCIPAL
      );
    },
    isOwnedBySubPrincipal() {
      if (!this.editedItem.principal?.length) {
        return false;
      }
      if (this.isRegionEditUser) {
        return false;
      }
      return this.editedItem.principal !== this.currentPrincipal?.id;
    },
    featureGroups() {
      return this.$store.state.featureGroups;
    },
    ownFeatureGroups() {
      return (
        this.featureGroups?.filter(
          featureGroup => featureGroup.owner === this.currentPrincipal?.id
        ) ?? []
      );
    },
    ownFeatures() {
      return this.ownFeatureGroups
        .map(featureGroup => featureGroup.features)
        .flat()
        .map(feature => feature._id);
    },
    cValid: {
      get() {
        return this.isValid;
      },
      set(value) {
        this.$emit("validChange", value);
      }
    },
    isValidDiff() {
      if (!this.isOwnedBySubPrincipal) {
        return true;
      }

      const diff = this.getObjectDiff(this.editedItem, this.initialPOI);
      if (diff.every(_key => _key === "description")) {
        let isWhiteSpaceDiffOnly = true;
        for (const key of Object.keys(this.editedItem.description)) {
          if (
            this.editedItem.description[key].trim() !==
            this.initialPOI.description[key].trim()
          ) {
            isWhiteSpaceDiffOnly = false;
            break;
          }
        }
        if (isWhiteSpaceDiffOnly) {
          return true;
        }
      }

      const features = [
        ...(this.editedItem.features ?? []),
        ...(this.initialPOI.features ?? [])
      ];
      const featuresDiff = features.filter(
        feature =>
          features.filter(_feature => _feature === feature).length === 1
      );
      if (!featuresDiff.every(feature => this.ownFeatures.includes(feature))) {
        return false;
      }

      const possiblyValidFields = ["features"];
      for (const field of diff) {
        if (possiblyValidFields.includes(field)) {
          continue;
        }
        if (
          this.isEmptyValue(this.editedItem[field]) &&
          this.isEmptyValue(this.initialPOI[field])
        ) {
          continue;
        }
        return false;
      }

      return true;
    }
  },
  methods: {
    getThirdPartySystem,
    getObjectDiff,
    isEmptyValue,
    getPrincipalName,
    getIsOwnedBySubPrincipalWarningHTML,
    onCKEditorReady,
    changeStep(value) {
      this.errorDialog = false;
      this.$emit("changeStep", value);
    },
    checkValid() {
      this.errorList = [];
      if (this.isValid) {
        return true;
      }
      const form = this.$refs.form;
      form.validate();
      const invalidFields = form._data.inputs.filter(i => !i.valid);
      invalidFields.forEach(field => {
        this.errorList.push({
          field: field?.$vnode?.componentOptions?.propsData?.label?.replace(
            "*",
            ""
          ),
          validations: field.validations
        });
      });
      this.errorDialog = true;
      return false;
    }
  },
  components: { POIStepsWrapper, ValidationDialog },
  watch: {
    dialog(newValue) {
      delete window._ckeditorReady;

      if (newValue && this.isOwnedBySubPrincipal) {
        const firstValidStep = this.validStepsForOwnedBySubPrincipal[0];
        this.changeStep(firstValidStep);
      } else if (!this.isOwnedBySubPrincipal) {
        return;
      }

      if (newValue) {
        const interval = setInterval(() => {
          if (!window._ckeditorReady) {
            return;
          }
          clearInterval(interval);
          this.initialPOI = window.structuredClone(this.editedItem);
        }, 1000);
      }
    }
  }
};
